import { render, staticRenderFns } from "./ReportSaberTyT.vue?vue&type=template&id=b9e30f10"
import script from "./ReportSaberTyT.vue?vue&type=script&lang=js"
export * from "./ReportSaberTyT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports